import Navbar from "./Navbar";

const MainNavigation = () => {
  return (
    <>
      <Navbar />
    </>
  );
};

export default MainNavigation;
